import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {layout} from 'icsoc-antd-ex';
import {message} from 'antd';
import {translateObjToString} from 'Utils';
import UnionComponent from 'Components/union/unionComponent';
import exportTasksActions from 'Actions/systemSetting/exportTasks';
import TableList from './tableList';
import DownloadModal from './modal/downloadModal';
import ReloadModal from './modal/reloadModal';

const {BaseContentMainHeader} = layout;

class ExportTasks extends UnionComponent {
  constructor(props) {
    super(props);

    this.state = {
      tableListLoading: false, // 列表loading
      downloadModalVisible: false, // 下载弹框是否可见
      reloadModalVisible: false, // 重新创建弹框是否可见
    };
  }

  componentWillUnmount() {
    const {actions} = this.props;
    actions.setPageStatus({pageNum: 1, pageSize: 20});
  }

  // 设置下载弹框显示隐藏
  setDownloadModalVisible = () => {
    const {downloadModalVisible} = this.state;
    this.setState({
      downloadModalVisible: !downloadModalVisible,
    });
  };

  // 设置重新创建弹框显示隐藏
  setReloadModalVisible = () => {
    const {reloadModalVisible} = this.state;
    this.setState({
      reloadModalVisible: !reloadModalVisible,
    });
  };

  exportTask = taskName => {
    const {actions, reloadModalData} = this.props;
    const parmas = {
      taskName,
      id: reloadModalData.id,
    };
    const urlParmasStr = translateObjToString(parmas);
    actions
      .reload(urlParmasStr)
      .then(res => {
        if (res.payload.code === 200) {
          message.success('创建导出任务成功！');
        }
      })
      .finally(() => {
        this.getTableList({pageNum: 1, pageSize: 20});
      });
  };

  render() {
    const {
      tableListLoading,
      downloadModalVisible,
      reloadModalVisible,
    } = this.state;

    return (
      <React.Fragment>
        <BaseContentMainHeader title="数据导出任务" />

        <TableList
          loading={tableListLoading}
          getTableList={this.getTableList}
          setDownloadModalVisible={this.setDownloadModalVisible}
          setReloadModalVisible={this.setReloadModalVisible}
        />

        {downloadModalVisible ? (
          <DownloadModal
            getTableList={this.getTableList}
            setDownloadModalVisible={this.setDownloadModalVisible}
          />
        ) : null}
        {reloadModalVisible ? (
          <ReloadModal
            getTableList={this.getTableList}
            setReloadModalVisible={this.setReloadModalVisible}
            exportTask={this.exportTask}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({systemSettingExportTasks}) => ({
  reloadModalData: systemSettingExportTasks.reloadModalData,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(exportTasksActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportTasks);
